import { Box, Button, Text, useMatchBreakpoints } from '@library/uikit'
import Page from 'components/Layout/Page'
import PageLoader from 'components/Loader/PageLoader'
import dynamic from 'next/dynamic'
import { NextRouter, useRouter } from 'next/router'
import { useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { NftTokenInWalletStatus } from '@common/types'
import Header from './Header'
import useGetGensForInWallet from '../hooks/useGetGensForInWallet'
import useWallet from '../../../../hooks/useWallet'
import { NftToken } from '../../../../state/nftMarket/types'

export const PageButtons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.2em;
  margin-bottom: 1.2em;
`

export const PageText = styled(Text)`
  font-size: 12px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 20px;
  }
`

export const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  color: white;

  height: 32px;
  width: 32px;
  margin: 0 10px;

  svg {
    width: 16px;
    height: 16px;
  }

  :hover {
    cursor: pointer;
  }
`

const getHashFromRouter = (router: NextRouter) => router.asPath.match(/#([a-z0-9]+)/gi)

const InWallet = dynamic(() => import('./InWallet'), {
  loading: () => <PageLoader />,
})
const OnSale = dynamic(() => import('./OnSale'), {
  loading: () => <PageLoader />,
})
const Offering = dynamic(() => import('./Offering'), {
  loading: () => <PageLoader />,
})

const Collectible = () => {
  const { isMobile } = useMatchBreakpoints()
  const router = useRouter()
  const hash = useMemo(() => getHashFromRouter(router)?.[0], [router])
  const { walletAddress } = useWallet()

  useEffect(() => {
    if (isMobile) {
      setTimeout(() => {
        window.scroll({
          top: 50,
          left: 0,
          behavior: 'smooth',
        })
      }, 50)
    }
  }, [isMobile])

  const { tokens, isLoading } = useGetGensForInWallet(walletAddress)

  let content = (
    <InWallet
      tokens={tokens}
      isLoading={isLoading}
      callback={(nft, status, id) => onOperateNFTStatus(nft, status, id)}
    />
  )

  if (hash === '#sale') {
    content = (
      <OnSale
        tokens={tokens}
        isLoading={isLoading}
        callback={(nft, status, id) => onOperateNFTStatus(nft, status, id)}
      />
    )
  }

  if (hash === '#offering') {
    content = <Offering />
  }

  const onOperateNFTStatus = (nft: NftToken, status: NftTokenInWalletStatus, id) => {
    console.info(`[撤单 融合 tokenId= ${nft.tokenId} status=${status} ]`)
    const currentToken = tokens.find((token) => token.tokenId === nft.tokenId)

    if (status === NftTokenInWalletStatus.SHOW_OFF) {
      const index = tokens.findIndex((token) => token.tokenId === nft.tokenId)
      tokens.splice(index, 1)
    }

    if (status === NftTokenInWalletStatus.CANCEL_FUSION) {
      currentToken.fusionId = id
    }

    if (status === NftTokenInWalletStatus.CANCEL_MARKET) {
      currentToken.marketId = id
    }
    currentToken.status = status
  }

  return (
    <>
      <Header />
      <Page>{content}</Page>
    </>
  )
}

export default Collectible
